import React from 'react';

import SettlementTable from './SettlementTable';

const MerchantPanel = ({ settlements }) => {
  return Array.isArray(settlements) ? <SettlementTable items={settlements} /> : null;
};

export default MerchantPanel;
